import EventEmitter from 'events';
import PricetypeSelector from './PricetypeSelector';

class ZonePricetypesCollection extends EventEmitter {
  /**
   * @param {HTMLElement} container
   * @param {string} selectedZoneId
   */
  constructor(container, selectedZoneId = null) {
    super();
    this.bindMethods();

    /** @type {Map<string, PricetypeSelector>} */
    this.pricetypeSelectors = new Map();

    const pricetypeContainers = Array.from(container.querySelectorAll('.tn-ticket-selector__pricetype-container'));

    pricetypeContainers.forEach((el) => {
      const zoneId = el.dataset.zoneId;
      const pricetypeSelector = new PricetypeSelector(el, zoneId);

      pricetypeSelector.on('change', this.onChange);

      this.pricetypeSelectors.set(zoneId, pricetypeSelector);
    });

    this.setCurrentZoneId(selectedZoneId);
  }

  bindMethods() {
    this.onChange = this.onChange.bind(this);
  }

  onChange() {
    this.emit('change');
  }

  /**
   * @param {string} zoneId
   */
  setCurrentZoneId(zoneId) {
    this.pricetypeSelectors.forEach((pricetypeSelector) => {
      if (pricetypeSelector.zoneId === zoneId) {
        pricetypeSelector.show();
      } else {
        pricetypeSelector.hide();
      }
    });

    this.zoneId = zoneId;
  }

  getCurrentPricetypeSelector() {
    if (this.zoneId === null) {
      return null;
    }

    return this.pricetypeSelectors.get(this.zoneId);
  }

  getTotalQuantitySelected() {
    const pricetypeSelector = this.getCurrentPricetypeSelector();

    if (pricetypeSelector) {
      return pricetypeSelector.getTotalQuantitySelected();
    }

    return 0;
  }

  getAllPricetypeQuantities() {
    const pricetypeSelector = this.getCurrentPricetypeSelector();

    if (pricetypeSelector) {
      return pricetypeSelector.getAllPricetypeQuantities();
    }

    return [];
  }

  /**
   * @param {{pricetypeId: string, quantity: number}} pricetypeQuantities
   */
  restoreSelectedQuantities(pricetypeQuantities) {
    const pricetypeSelector = this.getCurrentPricetypeSelector();
    const pricetypeMax = pricetypeSelector.getMaxQuantity();
    let restoringTotal = 0;

    Object.entries(pricetypeQuantities).forEach(([pricetypeId, quantity]) => {
      if (pricetypeSelector.hasPricetype(pricetypeId)) {
        restoringTotal += quantity;
      }
    });

    if (restoringTotal <= pricetypeMax) {
      Object.entries(pricetypeQuantities).forEach(([pricetypeId, quantity]) => {
        if (pricetypeSelector.hasPricetype(pricetypeId)) {
          pricetypeSelector.setSelectedQuantityForPricetype(pricetypeId, quantity);
        }
      });

      pricetypeSelector.updateSelectsForMax();
    }
  }

  destroy() {
    this.removeAllListeners();

    this.pricetypeSelectors.forEach((pricetypeSelector) => {
      pricetypeSelector.destroy();
    });
  }
}


export default ZonePricetypesCollection;



// WEBPACK FOOTER //
// ./V7/events/detail/ZonePricetypesCollection.js